import React from "react";

const DetectionResults = ({ traits }) => {
  return (
    <div className="about-text">
      <h2>MBTI Personality Type: {traits?.mbti_type}</h2>
      <h3>Description: {traits?.description}</h3>
      <div>
        <h5>
          Traits: <span style={{ textAlign: "justify" }}>{traits?.traits}</span>
        </h5>
      </div>
    </div>
  );
};

export default DetectionResults;
